import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Icon, Header, Input, Flag, Popup } from 'semantic-ui-react';
import ReactExport from 'react-data-export';
import cn from 'classnames';
import {
  Accounts,
  Portfolio,
  FundAllocator,
  ReallocateAccount,
  Api,
} from 'actions';
import { Segment, Loading, Button as CompButton } from 'components';
import { colors } from 'utils/colors';
import { isQuoteMedia } from 'utils/helpers';
import StepBar from './StepBar';
import AccountSelector from './AccountSelector';
import TradeTable from './TradeTable';
import { translation as translationCommon } from '../../Translation/common';
import { translation as translationTools } from '../../Translation/tools';

const { ExcelFile, ExcelSheet, ExcelColumn } = ReactExport;

class PortfolioReallocate extends Component {
  componentDidMount() {
    const { dispatch, accountList, portfolios } = this.props;

    if (!accountList) {
      dispatch(Accounts.fetchAll());
    }

    if (portfolios.length === 0) {
      dispatch(Portfolio.fetchUser());
    }
  }

  setAccount = (account) => {
    const { dispatch, reallocate } = this.props;
    const { selectedAccount } = reallocate;

    if (
      account &&
      selectedAccount &&
      selectedAccount.some((a) => a.id === account.id)
    ) {
      dispatch(ReallocateAccount.removeItem('selectedAccount', account.id));
    } else {
      dispatch(ReallocateAccount.addItem('selectedAccount', account));
    }
  };

  setTarget = (account) => {
    const { dispatch, reallocate } = this.props;

    const { targetTypePorts, selectedTargetAcc, selectedTargetPort } =
      reallocate;

    if (targetTypePorts) {
      if (
        account &&
        selectedTargetPort &&
        selectedTargetPort.some((a) => a.id === account.id)
      ) {
        dispatch(
          ReallocateAccount.removeItem('selectedTargetPort', account.id)
        );
      } else {
        dispatch(ReallocateAccount.addItem('selectedTargetPort', account));
      }
    } else if (
      account &&
      selectedTargetAcc &&
      selectedTargetAcc.some((a) => a.id === account.id)
    ) {
      dispatch(ReallocateAccount.removeItem('selectedTargetAcc', account.id));
    } else {
      dispatch(ReallocateAccount.addItem('selectedTargetAcc', account));
    }
  };

  handleChange = (e, { name, value }) => {
    const { dispatch } = this.props;

    dispatch(ReallocateAccount.updateParameter(name, value));
  };

  handleMoneyChange = (e, { name, value }) => {
    const { dispatch } = this.props;

    const raw = value.replace(/[^0-9.]/g, '');

    if (!/^\d*\.?\d{0,2}$/.test(raw)) {
      return;
    }

    if (name === 'commission' && parseFloat(raw) > 99.99) {
      dispatch(ReallocateAccount.updateParameter(name, 99.99));
      return;
    }

    dispatch(ReallocateAccount.updateParameter(name, raw));
  };

  formatMoneyDisplay = (value) => (value || value === 0 ? `$${value}` : '$');

  generatePDF = () => {
    const { history } = this.props;

    return history.push(`/tools/portfolio-reallocate/pdf`);
  };

  formatData = async () => {
    const { dispatch } = this.props;

    await dispatch(ReallocateAccount.calcRebalance());
  };

  renderPage = () => {
    const {
      accountList,
      portfolios,
      dispatch,
      reallocate,
      french,
      partnerName,
      exchangeRate,
    } = this.props;
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    const {
      currentPage,
      selectedAccount,
      targetTypePorts,
      selectedTargetPort,
      selectedTargetAcc,
      confirmedPort,
      commission,
      loading,
      cashAmount,
      cashAdd,
      showUnmatchedWarning,
    } = reallocate;
    let targetAccountList = [];
    if (selectedAccount) {
      targetAccountList = accountList.filter(
        (account) => account.id !== selectedAccount.id
      );
    }

    const currency = selectedAccount.length
      ? selectedAccount.some((account) => account.currency === 'CAD')
        ? 'CAD'
        : 'USD'
      : 'CAD';

    if (selectedAccount && selectedAccount.length && accountList) {
      const selectedIds = selectedAccount.map((a) => a.id);
      targetAccountList = accountList.filter(
        (account) => selectedIds.indexOf(account.id) === -1
      );
    }

    const pages = [
      <div>
        {accountList.length > 0 ? (
          // eslint-disable-next-line react/jsx-fragments
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Header
                as="h2"
                style={{
                  fontSize: '1.5rem',
                  color: colors.darkBlue,
                  marginTop: '20px',
                }}
              >
                {
                  translationTools[language][translateEnding]
                    .ACCOUNT_SELECT_TITLE
                }
              </Header>
              <p style={{ color: '#6D6E71', textAlign: 'center' }}>
                {
                  translationTools[language][translateEnding]
                    .ACCOUNT_SELECT_SUBTITLE
                }
              </p>
            </div>
            <AccountSelector
              accounts={accountList}
              changeAccount={this.setAccount}
              checked={
                selectedAccount && selectedAccount.length
                  ? accountList.reduce((indices, acc, index) => {
                      if (selectedAccount.some((sel) => sel.id === acc.id)) {
                        indices.push(index);
                      }
                      return indices;
                    }, [])
                  : []
              }
              isAccount
            />
          </React.Fragment>
        ) : (
          <div style={{ width: '60%', textAlign: 'left', paddingLeft: '10%' }}>
            <h2>{translationTools[language][translateEnding].NO_ACCOUNTS}</h2>
            <p>
              {translationTools[language][translateEnding].NO_ACCOUNTS_SUBTITLE}
            </p>
          </div>
        )}
      </div>,
      <div>
        {!confirmedPort ? (
          // eslint-disable-next-line react/jsx-fragments
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Header
                as="h2"
                style={{
                  fontSize: '1.5rem',
                  color: colors.darkBlue,
                  marginTop: '20px',
                }}
              >
                {
                  translationTools[language][translateEnding]
                    .TARGET_SELECT_TITLE
                }
              </Header>
              <p style={{ color: '#6D6E71', textAlign: 'center' }}>
                {
                  translationTools[language][translateEnding]
                    .TARGET_SELECT_SUBTITLE
                }
              </p>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Popup
                trigger={
                  <TargetSelect
                    isActive={targetTypePorts}
                    onClick={() => {
                      dispatch(
                        ReallocateAccount.updateParameter(
                          'targetTypePorts',
                          true
                        )
                      );
                    }}
                    hoverColor={colors.blue}
                    backgrounColor="rgb(242, 245, 255)"
                  >
                    <Icon
                      name="folder open"
                      style={{
                        fontSize: '15px',
                        verticalAlign: 'initial',
                        color: 'black',
                      }}
                    />
                    {isQuoteMedia(partnerName)
                      ? 'Simulations'
                      : translationCommon[language].PORTFOLIOS}
                  </TargetSelect>
                }
                position="top center"
                wide
              >
                {translationTools[language][translateEnding].PORTFOLIO_SELECT}
              </Popup>
              <Popup
                trigger={
                  <TargetSelect
                    isActive={!targetTypePorts}
                    onClick={() => {
                      dispatch(
                        ReallocateAccount.updateParameter(
                          'targetTypePorts',
                          false
                        )
                      );
                    }}
                    hoverColor={colors.red}
                    backgrounColor="rgb(255, 241, 241)"
                  >
                    <Icon
                      name="book"
                      style={{
                        fontSize: '15px',
                        verticalAlign: 'initial',
                        color: 'black',
                      }}
                    />
                    {isQuoteMedia(partnerName)
                      ? 'Portfolios'
                      : translationCommon[language].ACCOUNTS}
                  </TargetSelect>
                }
                position="top center"
                wide
              >
                {translationTools[language][translateEnding].ACCOUNT_SELECT}
              </Popup>
            </div>

            <AccountSelector
              accounts={targetTypePorts ? portfolios : targetAccountList}
              changeAccount={this.setTarget}
              checked={
                targetTypePorts
                  ? selectedTargetPort && selectedTargetPort.length
                    ? portfolios.reduce((indices, port, index) => {
                        if (
                          selectedTargetPort.some((sel) => sel.id === port.id)
                        ) {
                          indices.push(index);
                        }
                        return indices;
                      }, [])
                    : []
                  : selectedTargetAcc && selectedTargetAcc.length
                  ? targetAccountList.reduce((indices, acc, index) => {
                      if (selectedTargetAcc.some((sel) => sel.id === acc.id)) {
                        indices.push(index);
                      }
                      return indices;
                    }, [])
                  : []
              }
              isAccount={!targetTypePorts}
            />
          </React.Fragment>
        ) : (
          <div style={{ width: '65%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingBottom: '1rem',
                paddingTop: '2rem',
              }}
            >
              <p>
                {translationTools[language][translateEnding].CURRENT_BALANCE}
              </p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <DisabledInput>
                  {this.formatMoneyDisplay(
                    selectedAccount && selectedAccount.length
                      ? selectedAccount
                          .reduce((sum, a) => {
                            const bal =
                              a.currency === currency
                                ? Number(a.balance || 0)
                                : currency === 'USD'
                                ? Number((a.balance || 0) / exchangeRate)
                                : Number((a.balance || 0) * exchangeRate);

                            return sum + bal;
                          }, 0)
                          .toFixed(2)
                      : 0
                  )}
                </DisabledInput>
                <Flag
                  style={{ marginLeft: '10px' }}
                  name={currency === 'USD' ? 'us' : 'ca'}
                />
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingBottom: '1rem',
                marginRight: '33px',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p>
                  {translationTools[language][translateEnding].ADD_WITHDRAW}
                </p>
                <div
                  style={{
                    textAlign: 'center',
                    paddingLeft: '2rem',
                  }}
                >
                  <StyledSpan
                    active={cashAdd}
                    onClick={() =>
                      this.handleChange(null, { name: 'cashAdd', value: true })
                    }
                  >
                    {translationTools[language][translateEnding].ADD}
                  </StyledSpan>
                  <StyledSpan
                    active={!cashAdd}
                    onClick={() =>
                      this.handleChange(null, { name: 'cashAdd', value: false })
                    }
                  >
                    {translationTools[language][translateEnding].WITHDRAW}
                  </StyledSpan>
                </div>
              </div>

              <RightAlignedInput
                type="text"
                name="cashAmount"
                value={this.formatMoneyDisplay(cashAmount)}
                onChange={this.handleMoneyChange}
                placeholder="$0.00"
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingBottom: '1rem',
                marginRight: '33px',
              }}
            >
              <p>
                {
                  translationTools[language][translateEnding]
                    .TARGET_PORT_COMMISSION
                }
              </p>
              <RightAlignedInput
                type="text"
                name="commission"
                value={this.formatMoneyDisplay(commission)}
                onChange={this.handleMoneyChange}
                placeholder="$0.00"
              />
            </div>
          </div>
        )}
      </div>,
      loading ? (
        <Loading active />
      ) : (
        <div>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Header
              as="h2"
              style={{
                fontSize: '1.5rem',
                color: colors.darkBlue,
                marginTop: '20px',
              }}
            >
              {translationTools[language][translateEnding].RESULTS_TITLE}
            </Header>
            <p style={{ color: '#6D6E71', textAlign: 'center' }}>
              {translationTools[language][translateEnding].RESULTS_SUBTITLE}
            </p>
            {showUnmatchedWarning && (
              <p style={{ color: colors.red, textAlign: 'center' }}>
                {
                  translationTools[language][translateEnding]
                    .RESULTS_UNMATCHED_WARNING
                }
              </p>
            )}
          </div>
          <div
            style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            <TradeTable
              exchange={
                selectedAccount && selectedAccount.length
                  ? selectedAccount[0].usd2cad
                  : 1
              }
              currency={currency}
            />
          </div>
          <div>
            <CompButton
              onClick={this.generatePDF}
              className={cn('left grey-focus2', {
                // disabled: this.isDisable(),
              })}
              icon="file"
              color={colors.buttonGrey}
              style={{ margin: '2rem 1rem' }}
            >
              {translationCommon[language].PRINT_PDF}
            </CompButton>

            <ExcelFile
              element={
                <CompButton
                  className={cn('left grey-focus2', {
                    // disabled: this.isDisable(),
                  })}
                  icon="download"
                  color={colors.red}
                  style={{ margin: '2rem 1rem' }}
                >
                  {translationCommon[language].EXPORT_CSV}
                </CompButton>
              }
              filename="Portfolio_Reallocation"
            >
              <ExcelSheet
                data={Object.values(reallocate.tableData || {}).map((row) => {
                  let adjustedPrice = row.price;
                  const priceNum = Number(row.price);

                  if (row.currency === 'USD') {
                    adjustedPrice = (priceNum / exchangeRate).toFixed(2);
                  }

                  return {
                    ...row,
                    price: adjustedPrice,
                  };
                })}
                name="Reallocation"
              >
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_TICKER
                  }
                  value="ticker"
                />
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_LONG_NAME
                  }
                  value="name"
                />
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_CURRENT_QUANTITY
                  }
                  value="current_qty"
                />
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_TARGET_QUANTITY
                  }
                  value="target_qty"
                />
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_CURRENCY
                  }
                  value="currency"
                />
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_PRICE
                  }
                  value="price"
                />
                <ExcelColumn
                  label={
                    translationTools[language][translateEnding]
                      .RESULTS_EXCEL_CHANGE
                  }
                  value="action_amount"
                />
              </ExcelSheet>
            </ExcelFile>
          </div>
        </div>
      ),
    ];

    return pages[currentPage];
  };

  combineTickersFromAccounts = (accounts) => {
    const tickerMap = new Map();

    if (!accounts || !accounts.forEach) return tickerMap;

    accounts.forEach((acc) => {
      if (!acc || !acc.holdings) return;
      acc.holdings.forEach((h) => {
        if (!h) return;
        let ticker = null;
        if (h.security_detail && h.security_detail.ticker) {
          ({ ticker } = h.security_detail);
        } else if (h.security) {
          ticker = h.security;
        } else if (h.ticker) {
          ({ ticker } = h);
        }
        if (!ticker) return;

        const qty = Number(h.quantity || 0);

        if (!tickerMap.has(ticker)) {
          tickerMap.set(ticker, { quantity: qty });
        } else {
          const prev = tickerMap.get(ticker);
          prev.quantity = (prev.quantity || 0) + qty;
          tickerMap.set(ticker, prev);
        }
      });
    });

    return tickerMap;
  };

  combineTickersFromPorts = (ports) => {
    const tickerMap = new Map();

    if (!ports || !ports.forEach) return tickerMap;

    ports.forEach((port) => {
      if (!port) return;
      if (!port.symbols || !port.weights) return;

      const tickers = port.symbols.split(',').map((t) => t.trim());
      const weights = port.weights
        .split(',')
        .map((w) => (parseFloat(w.trim()) * 1) / ports.length);

      tickers.forEach((ticker, idx) => {
        if (!ticker) return;
        const weight = weights[idx] || 0;
        if (!tickerMap.has(ticker)) {
          tickerMap.set(ticker, weight);
        } else {
          const prev = tickerMap.get(ticker) || 0;
          tickerMap.set(ticker, prev + weight);
        }
      });
    });

    return tickerMap;
  };

  nextPage = async () => {
    const { dispatch, reallocate } = this.props;
    const {
      currentPage,
      confirmedPort,
      targetTypePorts,
      selectedAccount,
      selectedTargetAcc,
      selectedTargetPort,
      commission,
      cashAmount,
      cashAdd,
    } = reallocate;
    const currency = selectedAccount.length
      ? selectedAccount.some((account) => account.currency === 'CAD')
        ? 'CAD'
        : 'USD'
      : 'CAD';

    if (currentPage === 2) return;

    if (currentPage === 1 && !confirmedPort) {
      dispatch(ReallocateAccount.updateParameter('confirmedPort', true));
      return;
    }
    if (currentPage === 1 && !targetTypePorts && confirmedPort) {
      dispatch(ReallocateAccount.updateParameter('loading', true));
      dispatch(
        ReallocateAccount.updateParameter('showUnmatchedWarning', false)
      );

      const firstTargetAccLabel =
        selectedTargetAcc && selectedTargetAcc.length
          ? `${selectedTargetAcc[0].user_institution}: ${selectedTargetAcc[0].label}`
          : '';

      dispatch(
        Accounts.getHoldingsDiff(
          selectedAccount ? selectedAccount.map((account) => account.id) : [],
          firstTargetAccLabel,
          selectedTargetAcc
            ? selectedTargetAcc.map((account) => account.id)
            : []
        )
      ).then(async () => {
        await this.formatData();
        dispatch(ReallocateAccount.updateParameter('loading', false));
      });
    } else if (currentPage === 1 && targetTypePorts && confirmedPort) {
      dispatch(
        ReallocateAccount.updateParameter('showUnmatchedWarning', false)
      );

      const portTickerMap = this.combineTickersFromPorts(selectedTargetPort);
      const acctTickerMap = this.combineTickersFromAccounts(selectedAccount);

      const allTickers = Array.from(
        new Set(
          ((portTickerMap && Array.from(portTickerMap.keys())) || []).concat(
            (acctTickerMap && Array.from(acctTickerMap.keys())) || []
          )
        )
      );

      const quantities = allTickers.map((ticker) =>
        acctTickerMap && acctTickerMap.has(ticker)
          ? acctTickerMap.get(ticker).quantity
          : 0
      );

      const targetWeights = allTickers.map((ticker) =>
        portTickerMap && portTickerMap.has(ticker)
          ? portTickerMap.get(ticker)
          : 0
      );

      const hasUnmatched =
        selectedAccount &&
        selectedAccount.some(
          (acc) =>
            acc.holdings &&
            acc.holdings.some((item) => item.security_detail === null)
        );

      const currentPrices = [];

      if (hasUnmatched) {
        dispatch(
          ReallocateAccount.updateParameter('showUnmatchedWarning', true)
        );
      }

      const tickersToFetch = [];

      allTickers.forEach((ticker) => {
        let foundPrice = false;

        if (Array.isArray(selectedAccount)) {
          const matchingHolding = selectedAccount
            .flatMap((acc) => (acc && acc.holdings ? acc.holdings : []))
            .find((h) => {
              if (!h) return false;

              let securityTicker = null;
              if (h.security) {
                securityTicker = h.security;
              } else if (h.security_detail && h.security_detail.ticker) {
                securityTicker = h.security_detail.ticker;
              } else if (h.ticker) {
                securityTicker = h.ticker;
              }

              return securityTicker === ticker;
            });

          if (matchingHolding) {
            let price = null;

            if (
              matchingHolding.security_detail &&
              matchingHolding.security_detail.unadjusted_closing_price &&
              matchingHolding.security_detail.unadjusted_closing_price.CAD
            ) {
              price =
                matchingHolding.security_detail.unadjusted_closing_price.CAD;
            } else if (
              matchingHolding.unadjusted_closing_price &&
              matchingHolding.unadjusted_closing_price.CAD
            ) {
              price = matchingHolding.unadjusted_closing_price.CAD;
            }

            if (price !== null && price !== undefined) {
              currentPrices.push(`${price}:CAD`);
              foundPrice = true;
            }
          }
        }

        if (!foundPrice) {
          tickersToFetch.push(ticker);
          currentPrices.push('');
        }
      });

      if (tickersToFetch.length > 0) {
        await dispatch(
          Api.request('get', '/security/', {
            query: `?symbols=${tickersToFetch.join(',')}`,
          })
        ).then((result) => {
          if (result && result.forEach) {
            result.forEach((item) => {
              if (!item || !item.ticker) return;
              const idx = allTickers.indexOf(item.ticker);
              if (idx !== -1) {
                let priceString = '';
                if (
                  item.unadjusted_closing_price &&
                  item.unadjusted_closing_price.CAD
                ) {
                  priceString = `${item.unadjusted_closing_price.CAD}:CAD`;
                }
                currentPrices[idx] = priceString || currentPrices[idx];
              }
            });
          }
        });
      }

      const totalCash =
        selectedAccount && selectedAccount.reduce
          ? selectedAccount.reduce(
              (sum, acc) => sum + Number(acc && acc.cash ? acc.cash : 0),
              0
            )
          : 0;

      const cash_amount = cashAdd
        ? Number(cashAmount || 0) + totalCash
        : totalCash - Number(cashAmount || 0);

      const body = {
        tickers: allTickers.join(','),
        quantities: quantities.join(','),
        target_weights: targetWeights.join(','),
        cash_currency: currency,
        cash_amount,
        fee_per_trade: commission,
        ...(currentPrices.length > 0
          ? { current_prices: currentPrices.join(',') }
          : {}),
      };

      dispatch(ReallocateAccount.updateParameter('loading', true));

      dispatch(FundAllocator.calculate(body)).then(async () => {
        await this.formatData();
        dispatch(ReallocateAccount.updateParameter('loading', false));
      });
    }
    dispatch(ReallocateAccount.updateParameter('currentPage', currentPage + 1));
  };

  prevPage = () => {
    const { dispatch, reallocate } = this.props;
    const { currentPage, confirmedPort } = reallocate;

    if (currentPage === 0) return;

    if (currentPage === 1 && confirmedPort) {
      dispatch(ReallocateAccount.updateParameter('confirmedPort', false));

      return;
    }
    dispatch(ReallocateAccount.updateParameter('currentPage', currentPage - 1));
  };

  isNextDisabled = () => {
    const { reallocate } = this.props;
    const {
      currentPage,
      confirmedPort,
      targetTypePorts,
      selectedAccount,
      selectedTargetPort,
      selectedTargetAcc,
      commission,
      cashAmount,
    } = reallocate;
    return (
      (currentPage === 0 && (!selectedAccount || !selectedAccount.length)) ||
      (currentPage === 1 &&
        !targetTypePorts &&
        (!selectedTargetAcc || !selectedTargetAcc.length)) ||
      (currentPage === 1 &&
        targetTypePorts &&
        !confirmedPort &&
        (!selectedTargetPort || !selectedTargetPort.length)) ||
      (currentPage === 1 && confirmedPort && (!cashAmount || !commission))
    );
  };

  render() {
    const { reallocate, french, partnerName } = this.props;
    const language = french ? 'fr' : 'en';
    const translateEnding = isQuoteMedia(partnerName)
      ? 'PORTFOLIO_REALLOCATE_QM'
      : 'PORTFOLIO_REALLOCATE';

    const {
      currentPage,
      selectedAccount,
      targetTypePorts,
      selectedTargetPort,
      selectedTargetAcc,
    } = reallocate;

    return (
      <Segment
        padding="0rem"
        textAlign="center"
        style={{
          position: 'relative',
          minHeight: '700px',
          overflowX: 'hidden',
        }}
      >
        <Header
          size="large"
          textAlign="center"
          style={{ paddingBottom: '2rem' }}
        >
          <Header.Content>
            {translationTools[language][translateEnding].TITLE}
          </Header.Content>
          <Header.Subheader>
            {translationTools[language][translateEnding].SUBTITLE}
          </Header.Subheader>
        </Header>
        <StepBar
          currentStep={currentPage}
          accountText={
            selectedAccount && selectedAccount.length
              ? selectedAccount.length === 1
                ? selectedAccount[0].user_institution
                : `${selectedAccount.length} ${
                    isQuoteMedia(partnerName)
                      ? ' portfolios selected'
                      : french
                      ? ' comptes sélectionnés'
                      : ' accounts selected'
                  }`
              : ''
          }
          targetText={
            targetTypePorts
              ? selectedTargetPort && selectedTargetPort.length
                ? selectedTargetPort.length === 1
                  ? selectedTargetPort[0].name
                  : `${selectedTargetPort.length} ${
                      isQuoteMedia(partnerName)
                        ? ' simulations selected'
                        : french
                        ? ' portefeuilles sélectionnés'
                        : ' portfolios selected'
                    }`
                : ''
              : selectedTargetAcc && selectedTargetAcc.length
              ? selectedTargetAcc.length === 1
                ? selectedTargetAcc[0].user_institution
                : `${selectedAccount.length} ${
                    isQuoteMedia(partnerName)
                      ? ' portfolios selected'
                      : french
                      ? ' comptes sélectionnés'
                      : ' accounts selected'
                  }`
              : ''
          }
        />
        {this.renderPage()}
        <div style={{ height: '5rem' }} />
        {currentPage !== 2 && (
          <CompButton
            className={cn('right', {
              disabled: this.isNextDisabled(),
            })}
            color={colors.blue}
            icon="chevron right"
            floated="right"
            onClick={() => this.nextPage()}
            style={{
              position: 'absolute',
              bottom: '30px',
              right: '40px',
            }}
          >
            {translationCommon[language].NEXT}
          </CompButton>
        )}
        {currentPage !== 0 && (
          <CompButton
            className={cn('left', {
              // disabled: !Object.keys(selectedAssets).length,
            })}
            color={colors.blue}
            icon="chevron left"
            floated="left"
            onClick={() => this.prevPage()}
            style={{
              position: 'absolute',
              bottom: '30px',
              left: '40px',
            }}
          >
            {translationCommon[language].BACK}
          </CompButton>
        )}
      </Segment>
    );
  }
}

const TargetSelect = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  border: 1px solid
    ${({ isActive, hoverColor }) => (isActive ? hoverColor : colors.lightGrey)};
  background-color: ${({ isActive, backgrounColor }) =>
    isActive ? backgrounColor : 'white'};

  border-radius 10px;
  cursor: pointer;
  width: 47%;
  padding: 1rem;
  margin: 1rem;
  :hover {
    border: 1px solid ${({ hoverColor }) => hoverColor};
  }
`;

const StyledSpan = styled.span`
  padding: 0.3rem 0.7rem;
  cursor: pointer;
  font-size: 0.8rem;
  color: ${(props) => (props.active ? 'white' : 'black')};
  background-color: ${(props) => (props.active ? colors.blue : 'white')};
  border: ${(props) =>
    props.active ? '1px solid transparent' : '1px solid #dcdcdc'};
  user-select: none;

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  &:hover {
    border: 1px solid ${colors.blue};
  }
`;

const DisabledInput = styled.div`
  color: black;
  background-color: ${colors.lightGrey};
  border: 1px solid ${colors.grey};
  cursor: default;
  opacity: 0.5;
  border-radius: 0.28571429rem;
  align-content: center;
  padding: 0.5rem;
  width: 204px;
  text-align: end;
`;

const RightAlignedInput = styled(Input)`
  &&& input {
    text-align: right;
  }
`;

PortfolioReallocate.propTypes = {
  dispatch: PropTypes.func.isRequired,
  accountList: PropTypes.array,
  portfolios: PropTypes.array,
  history: PropTypes.object.isRequired,
  reallocate: PropTypes.object,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
  exchangeRate: PropTypes.number,
};
PortfolioReallocate.defaultProps = {
  accountList: [],
  portfolios: [],
  reallocate: {},
  french: false,
  partnerName: '',
  exchangeRate: null,
};

export default connect((state) => ({
  accountList: state.Accounts.accountList,
  portfolios: state.Portfolio.user,
  tradeRecommendations: state.Accounts.tradeRecommendations,
  fundallocator: state.FundAllocator,
  reallocate: state.ReallocateAccount,
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
  exchangeRate: Number(state.Storage['pwpa-exchange-rate']),
}))(PortfolioReallocate);
